import { MultiCheckboxFilterOption } from '../types';
import { MultiSelectCheckbox } from '../../components';

export const config: MultiCheckboxFilterOption = {
  id: 'omicsExplorer.filters.proteinEffect',
  title: {
    id: 'omicsExplorer.filters.proteinEffect',
    defaultMessage: 'Protein Effect',
  },
  content: MultiSelectCheckbox,
  injectedProps: {
    searchKey: 'proteinEffect',
    checkboxOptions: [
      {
        id: 'omicsExplorer.filters.proteinEffect.gainOfFunction',
        searchValue: 'gain of function',
        intlLabel: {
          id: 'omicsExplorer.filters.proteinEffect.gainOfFunction',
          defaultMessage: 'Gain of Function',
        },
      },
      {
        id: 'omicsExplorer.filters.proteinEffect.gainOfFunctionPredicted',
        searchValue: 'gain of function - predicted',
        intlLabel: {
          id: 'omicsExplorer.filters.proteinEffect.gainOfFunctionPredicted',
          defaultMessage: 'Gain of Function - Predicted',
        },
      },
      {
        id: 'omicsExplorer.filters.proteinEffect.lossOfFunction',
        searchValue: 'loss of function',
        intlLabel: {
          id: 'omicsExplorer.filters.proteinEffect.lossOfFunction',
          defaultMessage: 'Loss of Function',
        },
      },
      {
        id: 'omicsExplorer.filters.proteinEffect.lossOfFunctionPredicted',
        searchValue: 'loss of function - predicted',
        intlLabel: {
          id: 'omicsExplorer.filters.proteinEffect.lossOfFunctionPredicted',
          defaultMessage: 'Loss of Function - Predicted',
        },
      },
      {
        id: 'omicsExplorer.filters.proteinEffect.noEffect',
        searchValue: 'no effect',
        intlLabel: {
          id: 'omicsExplorer.filters.proteinEffect.noEffect',
          defaultMessage: 'No Effect',
        },
      },
      {
        id: 'omicsExplorer.filters.proteinEffect.noEffectPredicted',
        searchValue: 'no effect - predicted',
        intlLabel: {
          id: 'omicsExplorer.filters.proteinEffect.noEffectPredicted',
          defaultMessage: 'No Effect - Predicted',
        },
      },
      {
        id: 'omicsExplorer.filters.proteinEffect.unknown',
        searchValue: 'unknown',
        intlLabel: {
          id: 'omicsExplorer.filters.proteinEffect.unknown',
          defaultMessage: 'Unknown',
        },
      },
    ],
  },
};
